const onReady = (callback) => {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
  else callback();
};
const all = (selector, callback) => document.querySelectorAll(selector).forEach(callback);
const setExpanded = (selector, value) => all(selector, (button) => { button.setAttribute('aria-expanded', String(value)); });
const focusableSelector = [
  'a[href]:not([tabindex="-1"])', 'button:not([disabled]):not([tabindex="-1"])',
  'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])'
].join(',');
const inertSelector = '.ptt-header__brand-band, .ptt-category-bar, main, .ptt-footer';
let activePanel = null, activeTrigger = null, inertNodes = [];
const getFocusable = (panel) => Array.from(panel.querySelectorAll(focusableSelector)).filter((node) => !node.closest('[hidden]') && node.offsetParent !== null);
const setBackgroundInert = (panel, value) => {
  if (!value) {
    inertNodes.forEach((node) => { node.inert = false; });
    inertNodes = [];
    return;
  }
  all(inertSelector, (node) => {
    if (node.inert || node === panel || node.contains(panel) || panel.contains(node)) return;
    node.inert = true;
    inertNodes.push(node);
  });
};
const focusPanel = (panel, preferredSelector) => {
  if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
  const target = preferredSelector ? panel.querySelector(preferredSelector) : getFocusable(panel)[0];
  (target || panel).focus({ preventScroll: true });
};
const openPanel = (panel, trigger, preferredSelector) => {
  if (!panel) return;
  activePanel = panel;
  activeTrigger = trigger || document.activeElement;
  panel.classList.add('is-open');
  panel.setAttribute('aria-hidden', 'false');
  setBackgroundInert(panel, true);
  focusPanel(panel, preferredSelector);
};
const closePanel = (panel, restoreFocus = true) => {
  if (!panel) return;
  const wasActive = activePanel === panel;
  if (!wasActive && !panel.classList.contains('is-open')) return;
  panel.classList.remove('is-open');
  panel.setAttribute('aria-hidden', 'true');
  if (!wasActive) return;
  setBackgroundInert(panel, false);
  const trigger = activeTrigger;
  activePanel = null;
  activeTrigger = null;
  if (restoreFocus && trigger && document.contains(trigger)) trigger.focus({ preventScroll: true });
};
const trapFocus = (event) => {
  if (event.key !== 'Tab' || !activePanel) return;
  const focusable = getFocusable(activePanel);
  if (!focusable.length) {
    event.preventDefault();
    activePanel.focus({ preventScroll: true });
    return;
  }
  const first = focusable[0], last = focusable[focusable.length - 1];
  if (!activePanel.contains(document.activeElement)) {
    event.preventDefault();
    first.focus({ preventScroll: true });
  } else if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus({ preventScroll: true });
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus({ preventScroll: true });
  }
};
onReady(() => {
  const megaMenu = document.querySelector('[data-mega-menu]');
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-drawer-close].ptt-cart-drawer__overlay');
  const closeMega = (restoreFocus = true) => {
    closePanel(megaMenu, restoreFocus);
    setExpanded('[data-mega-menu-open]', false);
    megaMenu?.dispatchEvent(new CustomEvent('pttek:mega-menu-close'));
  };
  const closeDrawer = (restoreFocus = true) => {
    if (overlay) overlay.hidden = true;
    closePanel(drawer, restoreFocus);
    setExpanded('[data-cart-drawer-open]', false);
  };
  const openMega = (trigger) => {
    closeDrawer(false);
    openPanel(megaMenu, trigger, '.ptt-mega__panel a, .ptt-mega__close');
    setExpanded('[data-mega-menu-open]', true);
  };
  const openDrawer = (trigger) => {
    closeMega(false);
    if (overlay) overlay.hidden = false;
    openPanel(drawer, trigger);
    setExpanded('[data-cart-drawer-open]', true);
    drawer?.closest('cart-component')?.dispatchViewEvent?.();
  };
  const panelFor = (trigger) => document.getElementById(trigger.getAttribute('aria-controls'));
  const setComingSoon = (trigger, open, restoreFocus = false) => {
    const panel = panelFor(trigger);
    const root = trigger.closest('.ptt-utility-coming-soon');
    trigger.setAttribute('aria-expanded', String(open));
    root?.classList.toggle('is-open', open);
    if (panel) { panel.hidden = !open; panel.setAttribute('aria-hidden', String(!open)); }
    if (restoreFocus) trigger.focus({ preventScroll: true });
  };
  const closeComingSoon = (restoreFocus = false, except = null) => all('[data-coming-soon-trigger][aria-expanded="true"]', (trigger) => {
    if (trigger !== except) setComingSoon(trigger, false, restoreFocus);
  });
  let suppressNotificationFocus = false;
  const setNotifications = (trigger, open, restoreFocus = false) => {
    const panel = document.getElementById(trigger.getAttribute('aria-controls')), root = trigger.closest('.ptt-notifications');
    trigger.setAttribute('aria-expanded', String(open));
    if (open) root?.classList.remove('is-dismissed');
    root?.classList.toggle('is-open', open);
    if (panel) panel.setAttribute('aria-hidden', String(!open));
    if (restoreFocus) trigger.focus({ preventScroll: true });
  };
  const closeNotifications = (restoreFocus = false, dismiss = false) => all('[data-header-notifications-trigger]', (trigger) => {
    const root = trigger.closest('.ptt-notifications');
    const wasOpen = trigger.getAttribute('aria-expanded') === 'true';
    if (dismiss && wasOpen) root?.classList.add('is-dismissed');
    suppressNotificationFocus = dismiss && restoreFocus && wasOpen;
    setNotifications(trigger, false, restoreFocus && wasOpen);
    suppressNotificationFocus = false;
  });
  const closestTo = (event, selector) => event.target?.closest?.(selector);
  const focusInside = (root, event) => {
    const next = event.relatedTarget || document.activeElement; return next && root.contains(next);
  };
  all('[data-mega-menu-open]', (button) => button.addEventListener('click', (event) => { event.preventDefault(); openMega(button); }));
  all('[data-mega-menu-close]', (button) => button.addEventListener('click', (event) => { event.preventDefault(); closeMega(); }));
  all('[data-cart-drawer-open]', (button) => button.addEventListener('click', () => openDrawer(button)));
  all('[data-cart-drawer-close]', (button) => button.addEventListener('click', () => closeDrawer()));
  window.addEventListener('pttek:cart-open', () => openDrawer(document.activeElement));
  all('[data-coming-soon-trigger]', (button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const open = button.getAttribute('aria-expanded') !== 'true';
      closeComingSoon(false, button);
      closeNotifications();
      setComingSoon(button, open);
    });
  });
  all('[data-header-notifications-trigger]', (button) => {
    const root = button.closest('.ptt-notifications');
    let closeTimer = null;
    const cancelClose = () => { if (closeTimer !== null) { clearTimeout(closeTimer); closeTimer = null; } };
    const openNotifications = (allowDismissed = false) => { cancelClose(); if (!allowDismissed && root?.classList.contains('is-dismissed')) return; setNotifications(button, true); };
    const closeNotificationsLater = () => {
      cancelClose();
      closeTimer = setTimeout(() => { closeTimer = null; if (!root?.contains(document.activeElement)) setNotifications(button, false); }, 200);
    };
    button.addEventListener('click', () => { closeComingSoon(); openNotifications(true); });
    root?.addEventListener('mouseenter', () => openNotifications());
    root?.addEventListener('mouseleave', () => { root.classList.remove('is-dismissed'); if (!root.contains(document.activeElement)) closeNotificationsLater(); });
    root?.addEventListener('focusin', () => { if (!suppressNotificationFocus) openNotifications(true); });
    root?.addEventListener('focusout', (event) => { if (!focusInside(root, event)) { cancelClose(); setNotifications(button, false); } });
  });
  document.addEventListener('click', (event) => {
    if (!closestTo(event, '.ptt-utility-coming-soon')) closeComingSoon();
    if (!closestTo(event, '.ptt-notifications')) closeNotifications();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMega();
      closeDrawer();
      closeComingSoon(true);
      closeNotifications(true, true);
      return;
    }
    trapFocus(event);
  });

  all('[data-scoped-search]', (form) => {
    const toggle = form.querySelector('[data-search-scope-toggle]');
    const list = form.querySelector('[data-search-scope-list]');
    const label = form.querySelector('[data-search-scope-label]');
    const input = form.querySelector('[data-search-scope-input]');
    if (!toggle || !list || !label || !input) return;
    const setOpen = (open) => { list.hidden = !open; toggle.setAttribute('aria-expanded', String(open)); };
    toggle.addEventListener('click', () => setOpen(list.hidden));
    list.querySelectorAll('[data-search-scope-option]').forEach((option) => {
      option.addEventListener('click', () => {
        const scope = option.textContent.trim();
        label.textContent = scope;
        const template = input.dataset.placeholderTemplate || '';
        if (template) input.placeholder = template.replace('[scope]', scope);
        list.querySelectorAll('[data-search-scope-option]').forEach((node) => node.classList.toggle('is-active', node === option));
        setOpen(false);
        input.focus();
      });
    });
    document.addEventListener('click', (event) => { if (!form.contains(event.target)) setOpen(false); });
    form.addEventListener('keydown', (event) => { if (event.key === 'Escape') setOpen(false); });
  });
});
